import { format } from "@hejdoktor/resx-compiler"
const pluralRules = new Intl.PluralRules("en")

export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CallIssueCamera": "There is a problem accessing your camera.",
	"CallIssueMicrophone": "There is a problem accessing your microphone.",
	"CallIssueNetwork": "There is a problem with the network connection.",
	"CallIssueReconnectQuestion": "Do you want to try to reconnect?",
	"CallIssueTitle": "Something is wrong",
	"CallQualityFeedback_Bad": "Bad",
	"CallQualityFeedback_Ok": "Good!",
	"CallQualityFeedback_Title": "How was the technical quality of the call?",
	"CallReJoinButton": "Re-join",
	"Camera": "Camera",
	"CameraOffTooltip": "Turn off camera",
	"CameraOnTooltip": "Turn on camera",
	"Close": "Close",
	"Connected": "Connected",
	"Connecting": "Connecting...",
	"DeviceSelectionDropdownCameraPlaceholderChoose": "Choose camera",
	"DeviceSelectionDropdownCameraPlaceholderEmpty": "No cameras found",
	"DeviceSelectionDropdownMicrophonePlaceholderChoose": "Choose microphone",
	"DeviceSelectionDropdownMicrophonePlaceholderEmpty": "No microphones found",
	"DeviceSelectionDropdownSpeakerPlaceholderChoose": "Choose a speaker",
	"DeviceSelectionDropdownSpeakerPlaceholderEmpty": "No speakers found",
	"DeviceSelectionDropdownSpeakerPlaceholderSystemDefault": "System default",
	"DeviceSetupCameraPermissionDeniedHint": "To participate in the video consultation, you need to give access to your camera.",
	"DeviceSetupContinue": "Join",
	"DeviceSetupDone": "Done",
	"DeviceSetupHelpLink": "Do you need help?",
	"DeviceSetupMicrophoneHint": "The others will be able to hear you when the volume indicator moves as you speak.",
	"DeviceSetupMicrophonePermissionDeniedHint": "To participate in the video consultation, you need to give access to your microphone.",
	"DeviceSetupPermissionDeniedModalDescription": "Allow hejdoktor.dk to access your camera and microphone to participate in the video consultation.",
	"DeviceSetupPermissionDeniedModalDescriptionDisclaimer": "You can turn off the camera and microphone at any time during the consultation.",
	"DeviceSetupPermissionDeniedModalDescriptionReloadInstruction": "After allowing access, please reload the page to continue.",
	"DeviceSetupPermissionDeniedModalTitle": "Camera and microphone permission denied",
	"DeviceSetupSpeakerTest": "Play sound",
	"DeviceSetupSubtitle": "Check your speaker, microphone and camera. Press continue when you are ready to start the call.",
	"DeviceSetupTitle": "Join the consultation",
	"DeviceSetupTitleSetupOnly": "Test your device settings",
	"Disconnected": "Disconnected",
	"Disconnecting": "Disconnecting",
	"DoYouWantToEndTheCall": "Do you want to end the call?",
	"ErrorCallQualityFeedback": "Could not save your feedback",
	"Ignore": "Ignore",
	"LeavingCall": "Leaving...",
	"LocalPreviewCameraOff": "Your camera is turned off",
	"Microphone": "Microphone",
	"MicrophoneOffTooltip": "Turn on microphone",
	"MicrophoneOnTooltip": "Turn off microphone",
	"PhoneCallPopupDescription": "You are about to call the patient via telephone. You can still use video to assess the patient's issue",
	"PhoneCallPopupEndCallButtonText": "End phone call",
	"PhoneCallPopupTitleConnected": "Phone call connected",
	"PhoneCallPopupTitleConnecting": "Calling the patient",
	"Reconnect": "Reconnect",
	"Reconnecting": "Reconnecting",
	"ScreenShareOffTooltip": "Start screen sharing",
	"ScreenShareOnTooltip": "Stop screen sharing",
	"Settings": "Settings",
	"SettingsTooltip": "Settings",
	"Speaker": "Speaker",
	"StartPhoneCall": "Call on phone",
	"StartPhoneCallTooltip": "If technical challenges arise, you can call the patient via telephone.",
	"Starting": "Starting",
	"VideoLoadingTooltip": "Camera is loading",
	"YouAreTheLastOneHere": "You are the last one here",
	"WaitingForDoctor": "Waiting on {0}",
	"BackToConsultations": "Back to my consultations",
	"ApproxWaitingTime": (number: number, { minimumFractionDigits = 0, maximumFractionDigits = 3 }: { minimumFractionDigits?: number, maximumFractionDigits?: number } = {}) => {
		const nf = new Intl.NumberFormat("en", { minimumFractionDigits, maximumFractionDigits })
		switch(pluralRules.select(number)) {
			case "one":
				return format("Waiting time is around 1 minute.", nf.format(number))
			default:
			case "other":
				return format("Waiting time is around {0} minutes.", nf.format(number))
		}
	},
	"Excellent": "Excellent",
	"Good": "Good",
	"Bad": "Bad",
	"Unknown": "Unknown",
	"Connection": "Connection",
	"NetworkStatus": "Networkstatus",
	"WaitingForPatient": "Waiting for the patient",
	"DeviceCameraPermissionDeniedModalDescriptionFirstStep": "Close external applications that might be using your camera.",
	"DeviceCameraPermissionDeniedModalDescriptionSecondStep": "If you're using external camera try disconnecting and connecting it again.",
	"DeviceCameraPermissionDeniedModalDescriptionThirdStep": "Close and reopen your browser.",
	"DeviceMicrophonePermissionDeniedModalDescriptionFirstStep": "Close external applications that might be using your microphone.",
	"DeviceMicrophonePermissionDeniedModalDescriptionSecondStep": "If you're using external microphone try disconnecting and connecting it again.",
	"DeviceMicrophonePermissionDeniedModalDescriptionThirdStep": "Close and reopen your browser.",
	"DeviceSetupPermissionDeniedModalDescriptionFirstStep": "Close external applications that might be using your camera/microphone.",
	"DeviceSetupPermissionDeniedModalDescriptionSecondStep": "If you're using external camera/microphone try disconnecting and connecting it again.",
	"DeviceSetupPermissionDeniedModalDescriptionThirdStep": "Close and reopen your browser.",
	"DeviceCameraPermissionDeniedModalDescription": "Allow hejdoktor.dk to access your camera to participate in the video consultation.",
	"DeviceMicrophonePermissionDeniedModalDescription": "Allow hejdoktor.dk to access your microphone to participate in the video consultation.",
	"DeviceCameraPermissionDeniedModalDescriptionDisclaimer": "You can turn off the camera at any time during the consultation.",
	"DeviceMicrophonePermissionDeniedModalDescriptionDisclaimer": "You can turn off the microphone at any time during the consultation.",
	"DeviceCameraPermissionDeniedModalTitle": "Camera permission denied",
	"DeviceMicrophonePermissionDeniedModalTitle": "Microphone permission denied",
	"ChooseBackground": "Choose a background",
	"AddBackground": "Add background",
	"Blur": "Blur",
	"None": "None",
	"NoAnswerInfoHeader": "Couldn't connect with the patient?",
	"NoAnswerInfoText": "Try calling the patient first. If that fails, send an automated email inviting them to book a new appointment.",
	"Call": "Call",
	"SendMail": "Send mail",
	"EmailSent": "The email has been sent to the patient",
	"ErrorSentEmail": "ERROR: Could not send email to patient.",
	"TechnicalIssues": "Were there any technical issues?",
	"EndVideo": "End video",
}